import script from "./SubmitFenxiangguan.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitFenxiangguan.vue?vue&type=script&setup=true&lang=js"

import "./SubmitFenxiangguan.vue?vue&type=style&index=0&id=12ee41dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ee41dc"]])

export default __exports__